import React, { useState, useEffect } from 'react';
/** Services Import */
import M_NOT_BASIC from './M_NOT_BASIC';
import Commons from '../../../Services/Common/Common';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { closeLoading, showLoading } from '../../../Reducer/LoadingReducer';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch5,
} from './M_NOT_BASIC_Query';
import { useNavigate } from 'react-router-dom';
import { useBackStack } from '../../../Hooks/back/useBackStack';

function M_NOT_BASICF() {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const navigate = useNavigate();
  //로그인한 user 정보
  const [rowData1, setRowData1] = useState([]); // 공지사항 Data
  const [rowData2, setRowData2] = useState([]); // 게시글 Data
  const [value, setValue] = React.useState(0);

  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/Home'),
  });

  useEffect(() => {
    if (!userInfo || !userInfo.coCd) return;

    const ChangeValue = async () => {
      dispatch(showLoading());
      try {
        if (value === 0) {
          await Search1();
        } else if (value === 1) {
          const posts = await Search2Async();
          const policies = await Search3Async();
          const manuals = await Search5Async();

          const transformedPosts = Commons.InsertNumber(posts || []).map(
            (item) => ({
              ...item,
              prefix: 'N',
            })
          );

          const polData = policies?.[0];
          const transformedPolicies = polData
            ? [
                {
                  ...polData,
                  prefix: 'P',
                  name: polData.name?.trim()
                    ? polData.name
                    : '안전보건경영방침',
                },
              ]
            : [];

          const transformedManuals = Commons.InsertNumber(manuals || []).map(
            (item) => ({
              ...item,
              prefix: 'E',
              title: item?.title?.trim?.() ? item.title : '비상대응메뉴얼',
              // 서버 응답이 PascalCase일 수도 있어 폴백으로 정규화
              chaebun: item?.chaebun ?? item?.Chaebun,
              filePath: item?.filePath ?? item?.FilePath,
              saveName: item?.saveName ?? item?.SaveName,
              createId: item?.createId ?? item?.CreateId,
              updateDate: item?.updateDate ?? item?.UpdateDate,
            })
          );

          setRowData2([
            ...transformedPolicies,
            ...transformedManuals,
            ...transformedPosts,
          ]);
        }
      } catch (e) {
        console.error(e);
      } finally {
        dispatch(closeLoading());
      }
    };

    ChangeValue();
  }, [value, userInfo]);

  // 공지사항 조회(_value1:사용자정보)
  const { run: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(Commons.InsertNumber(rows));
    },
  });

  // 게시글 조회
  const { runAsync: Search2Async } = useSearch2();

  // 안전보건경영방침 조회
  const { runAsync: Search3Async } = useSearch3();

  // 비상대응메뉴얼(비상조치계획) 조회
  const { runAsync: Search5Async } = useSearch5();

  return (
    <div className="wrap">
      <M_NOT_BASIC
        rowData1={rowData1}
        setRowData1={setRowData1}
        rowData2={rowData2}
        setRowData2={setRowData2}
        setValue={setValue}
        value={value}
      />
    </div>
  );
}

export default M_NOT_BASICF;
